define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/locale",
	"csi/sessionConstants"
], function(def, Action, ActionFactory, locale, sessionConstants) {

	return ActionFactory.declare("tableExcel", Action, {
		m_id: "TableExcel",
		m_class: "far fa-file-excel",
		// Determine if action is affected by maximum row number limitation, only affects tooltip
		bMaxLimit: true,

		constructor: function() {
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable if data size is larger than max data size allowed for use
			return !ctx.view.doesQueryTotalExceedMax() && ctx.view.hasQueryResults() && this.inherited(arguments);
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: add max limit to tooltip
			this.inherited(arguments);

			if (this.bMaxLimit) {
				const max = sessionConstants.siteMaxExportSize;
				if (max) {
					this.m_tooltip += locale.resource("TableDisabledByLimit", [max]);
				}
			}
		},

		validate: function(/*Context*/ctx) {
			return !ctx.bPrint && (!ctx.fd || ctx.fd.m_bEditable);
		}
	});
});